module.exports = __webpack_public_path__ + "static/DB-f43b0bc079d39c2aab76c5378091e923.jpg";